import { Loading } from "@/components";
import { LayoutDefault } from "@/components/layouts/LayoutDefault";
import { createFileRoute, redirect } from "@tanstack/react-router";

const Page = () => {
  return (
    <LayoutDefault>
      <Loading />
    </LayoutDefault>
  );
};

export const Route = createFileRoute("/pr")({
  component: Page,
  beforeLoad: async ({ location }) => {
    const promo_code = Object.keys(location.search)[0];
    throw redirect({
      to: "/register/subscriptions",
      search: {
        promo_code,
      },
    });
  },
});
